export interface MentionMeParameters {
  email?: string;
  firstName?: string;
  locale: string;
  signup_id?: string;
  situation: string;
  surname?: string;
}
